import { useState } from "react";

//components
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import AddProject from '../AddProject'
import ProjectList from '../ProjectList'

const Projects = ()=>{
    const [showForm, setShowForm] = useState(false);
    const [reloadList, setReloadList] = useState(false)

    const handleProjectCreated = ()=>{
        setReloadList(prevState => !prevState);
        setShowForm(false);
    }
return (
        <div>
            <h1>Progetti</h1>
            <div className="template__Wrapper">
                <ProjectList reloadList={reloadList}/>
                <Button onClick={() => setShowForm(true)} style={{marginBottom:'2rem'}}> 
                    Aggiungi Progetto
                </Button>
                <Dialog
                    header="Aggiungi Progetto"
                    visible={showForm}
                    style={{ width: '50vw' }} 
                    modal
                    onHide={() => setShowForm(false)}
                >
                    <AddProject onProjectCreated={handleProjectCreated}  /> 
                </Dialog>
            </div>
        </div>
    )
}

export default Projects